import * as React from 'react';
import { connect } from 'react-redux';
import { isFunction, isPlainObject } from 'lodash';

import { IAction } from '../../interfaces/IAction';

interface IWithSagasOptions {
  onMount: any[];
  onUnmount: any[];
}

interface IwithActionsDispatchProps {
  dispatch: (action: IAction) => void | IAction;
}

const withActionsDispatch = (options: IWithSagasOptions) => {
  return <OriginalProps extends {}>(WrappedComponent: React.ComponentType<OriginalProps>) => {
    class WrappedComponentWithSagas extends React.PureComponent<IwithActionsDispatchProps> {
      public static displayName = `withActionsDispatch(${WrappedComponent.displayName})`;

      public dispatchActionsList = (actionsList: any[]) => {
        const { dispatch } = this.props;

        actionsList.forEach((entry: any) => {
          if (isFunction(entry)) {
            dispatch(entry());
          } else if (isPlainObject(entry)) {
            dispatch(entry);
          }
        });
      };

      public componentDidMount() {
        const { onMount } = options;
        this.dispatchActionsList(onMount);
      }

      public componentWillUnmount() {
        const { onUnmount } = options;
        this.dispatchActionsList(onUnmount);
      }

      public render() {
        return <WrappedComponent {...(this.props as any)} />;
      }
    }

    return connect(
      null,
      dispatch => {
        return {
          dispatch,
        };
      },
    )(WrappedComponentWithSagas);
  };
};

export default withActionsDispatch;



// WEBPACK FOOTER //
// ./src/hocs/withActionsDispatch/index.tsx